<template>
  <div class="main_right electronic-config-modify">
    <breadcrumb :breadcrumb="config.breadcrumb" />
    <div class="flexBox">
      <text-title mainTitle="收费配置" subheading="" />
      <div>
        <a @click="updateGasPayConfig">保存</a>
        <a @click="cel">取消</a>
      </div>
    </div>

    <form>
      <div>
        <div class="form-line">
          <div class="textBox">
            <span class="line-text">收费标准：</span>
          </div>
          <el-select v-model="feeType" size="small" style="width: 280px">
            <el-option v-for="item in feeTypeList" :key="item.code" :label="item.name" :value="item.code"> </el-option>
          </el-select>
        </div>
      </div>

      <div>
        <div class="form-line">
          <div class="textBox">
            <span class="line-text">热燃气单价：</span>
          </div>
          <el-input v-model="gasConfigData.gasUnitPrice" size="small" style="width: 280px" v-on:blur="hotUnitPriceChange()">
            <template slot="append">元/立方米</template>
          </el-input>
        </div>
      </div>

<!--      <div>-->
<!--        <div class="form-line">-->
<!--          <div class="textBox">-->
<!--            <span class="line-text">冷燃气单价：</span>-->
<!--          </div>-->
<!--          <el-input v-model="gasConfigData.coldUnitPrice" size="small" style="width: 280px" v-on:blur="coldUnitPriceChange()">-->
<!--            <template slot="append">元/立方米</template>-->
<!--          </el-input>-->
<!--        </div>-->
<!--      </div>-->
    </form>
  </div>
</template>

<script>
import { nError, nSuccess } from '../../../utils/notice'
import { errorHandler } from '../../../utils/errorHandler'
import { pattern } from '../../../utils/regular'
import { api } from '../../api/GasManagement'
import TextTitle from '../../../components/Text/TextTitle'
import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
import ButtonConfirm from '../../../components/Button/ButtonConfirm'
import ButtonCancel from '../../../components/Button/ButtonCancel'

export default {
  components: {
    ButtonCancel,
    ButtonConfirm,
    Breadcrumb,
    TextTitle,
  },
  name: 'modify-electronic-config',
  data() {
    return {
      config: {
        breadcrumb: [
          {
            value: '智慧燃气',
            name: 'gas-over-view',
          },
          {
            value: '收费配置',
          },
        ],
      },
      maxlength: 32,
      collectionAccountList: [],
      aliAccountName: '',
      aliAccountNo: '',
      feeType: '1',
      feeTypeList: [
        {
          code: '1',
          name: '固定定价',
        },
      ],
      gasConfigData: {
        feeType: '1',
        gasUnitPrice: '0',
        // coldUnitPrice: '0',
      },
    }
  },
  created() {},
  mounted() {
    this.getGasPayConfig()
  },
  methods: {
    cel() {
      this.$router.push({
        name: 'gas-config-center',
      })
    },
    hotUnitPriceChange() {
      if (this.gasConfigData.gasUnitPrice) {
        this.gasConfigData.gasUnitPrice = parseFloat(this.gasConfigData.gasUnitPrice).toFixed(2)
      } else {
        this.gasConfigData.gasUnitPrice = '0.00'
      }
    },

    coldUnitPriceChange() {
      if (this.gasConfigData.coldUnitPrice) {
        this.gasConfigData.coldUnitPrice = parseFloat(this.gasConfigData.coldUnitPrice).toFixed(2)
      } else {
        this.gasConfigData.coldUnitPrice = '0.00'
      }
    },

    getGasPayConfig() {
      this.$axios
        .post(api.getGasPayConfig, {})
        .then((res) => {
          let data = res.data.data
          if (data) {
            this.gasConfigData = data
          }
        })
        .catch(errorHandler('获取收费数据失败'))
    },
    updateGasPayConfig() {
      this.$axios
        .post(api.updateGasPayConfig, this.gasConfigData)
        .then((res) => {
          nSuccess('修改成功')
          this.cel()
        })
        .catch(errorHandler('修改失败'))
    },
  },
  watch: {},
}
</script>

<style scoped>
.main_right {
  text-align: left;
}
.flexBox {
  display: flex;
  justify-content: space-between;
}

.flexBox a {
  line-height: 58px;
  margin-right: 40px;
  cursor: pointer;
  color: #00a0e6;
}
.flexBox a:hover {
  color: #06b3ff;
}
form {
  width: 90%;
  margin: 0 auto;
  text-align: left;
}
form > div {
  display: flex;
  justify-content: flex-start;
}
.red {
  color: #ff0000;
}
.form-line {
  margin: 20px 0;
  line-height: 30px;
  display: flex;
  justify-content: flex-start;
}
.form-line > span {
  font-size: 12px;
  color: #97a8be;
}
.line-text {
  color: #48576a;
  font-size: 14px;
  margin-right: 10px;
}
.textBox {
  display: inline-block;
  width: 120px;
  text-align: right;
}
.form-btn-box {
  width: 530px;
  padding: 0 124px;
  margin-top: 40px;
  display: flex;
  justify-content: space-between;
}
</style>

<style lang="less">
.main_right {
  .faceConfigTip {
    display: inline-block;
    min-width: 80px;
    text-align: right;
  }
  .faceConfigInput {
    display: inline-block;
    width: 313px;
    height: 28px;
    margin-left: 10px;
    .el-input__inner {
      height: 28px;
    }
  }
}

.electronic-config-modify {
  .el-date-editor .el-range-separator {
    width: 14px;
    padding: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/GasManage/GasConfig/GasConfigModify.vue